'use client';
import React, { useEffect, useState } from 'react';
import getPostList, { type PostListItem as PostListItemType } from '@/actions/blog/getPostList';
import { Divider, Stack, Progress, HStack, Box, Text } from '@chakra-ui/react';
import PostListItem from '../PostListItem';
import Link from 'next/link';
import { FaChevronLeft } from 'react-icons/fa';
import { useT } from '@/app/i18n/client';

interface Term {
  term_id: number;
  name: string;
  slug: string;
}

interface Post {
  id: string;
  post_title: string;
  post_date: string;
  thumbnail: string;
  terms: Term[];
}

interface RelatedPostsProps {
  currentPostID: string | number;
}

export default function RelatedPosts({ currentPostID }: RelatedPostsProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [posts, setPosts] = useState<Post[]>([]);
  const { t } = useT();

  useEffect(() => {
    getPostList().then((res) => {
      if ('data' in res) {
        console.log('123', res.data);
        const transformedPosts = res.data
          .filter((post: PostListItemType) => post.ID !== currentPostID.toString())
          .slice(0, 2)
          .map((post: PostListItemType) => ({
            id: post.ID,
            post_title: post.post_title,
            post_date: post.post_date,
            thumbnail: post.thumbnail || '',
            terms: [],
          }));
        setPosts(transformedPosts);
      }
      setIsLoading(false);
    });
  }, []);

  if (isLoading)
    return (
      <Progress
        bg="#000"
        size="xs"
        isIndeterminate
      />
    );

  if (posts.length === 0)
    return (
      <Link href="/blog-all">
        <HStack gap="2">
          <FaChevronLeft />
          <Text
            fontSize="16px"
            lineHeight="24px"
            fontWeight="bold"
            color="#333333"
          >
            {t('morePosts')}
          </Text>
        </HStack>
      </Link>
    );

  return (
    <>
      <HStack gap="2">
        <Box
          w="3px"
          h="16px"
          bg="#000"
        />
        <Text
          fontSize="16px"
          lineHeight="24px"
          fontWeight="bold"
          color="#333333"
        >
          {t('relatedPosts')}
        </Text>
      </HStack>
      <Stack
        divider={<Divider />}
        gap="4"
      >
        {posts.map((data) => (
          <Link
            href={`/blog/${data.id}`}
            key={data.id}
          >
            <PostListItem
              key={data.id}
              data={data}
            />
          </Link>
        ))}
      </Stack>
    </>
  );
}
